import { Tag } from "antd";
import { RetweetOutlined } from "@ant-design/icons";
import { formatPhoneNumber } from "../../../../utils/appUtils";

const rowStyle = { margin: 0, padding: "5px 0" };

export const USER_COLUMNS = [
    {
        title: "SNo",
        width: 60,
        align: "center",
        render: (_, __, index) => <>{index + 1}</>
    },
    {
        title: "Name",
        dataIndex: "name",
        width: 150,
        key: "name",
        render: (text) => text || "Nil"
    },
    {
        title: "User Name",
        dataIndex: "userName",
        key: "userName",
        width: 150,
        render: (text) => text || "Nil"
    },
    {
        title: "Mobile Number",
        width: 150,
        dataIndex: "mobileNumber",
        key: "mobileNumber",
        render: (mobileNumber) => mobileNumber ? formatPhoneNumber(mobileNumber) : "Nil"
    },
    {
        title: "Email ID",
        width: 200,
        dataIndex: "emailId",
        key: "emailId",
        render: (text) => text || "Nil"
    },
    {
        title: "Role",
        width: 150,
        dataIndex: "role",
        key: "role",
        render: (text) => text || "Nil"
    },
    {
        title: "Status",
        dataIndex: "status",
        width: 80,
        key: "status",
        align: "center",
        render: (status) => {
            const formattedStatus = (status || "")?.toUpperCase() === "ACTIVE" ? "ACTIVE" : "INACTIVE";
            return (
                <div
                    style={{ cursor: "pointer", display: 'flex', justifyContent: 'center' }}
                >
                    <Tag color={formattedStatus === "ACTIVE" ? "success" : "error"}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                            <span style={{ fontSize: '20px', lineHeight: '10px' }}>•</span>
                            {formattedStatus === "ACTIVE" ? "Active" : "Inactive"}
                        </div>
                    </Tag>
                </div>
            );
        },
    },
    {
        title: "Reset",
        key: "reset",
        align: "center",
        width: 80,
        render: () => (
            <RetweetOutlined
                style={{ cursor: "pointer", color: "#CE9141", fontSize: "18px", ...rowStyle }}
            />
        ),
    },
];

export const ROLE_OPTIONS = [
    { value: "Admin", label: "Admin" },
    { value: "Support", label: "Support" },
    { value: "Sales", label: "Sales" }
];
